// extracted by mini-css-extract-plugin
export default {"header":"_3g1rQ","createPostButton":"_1k63T","tabs":"ouGjh"};